import { useState } from 'react';
import { useStore } from './ui/useStore.ts';
import { Today } from './ui/Today.tsx';
import { Week } from './ui/Week.tsx';
import { Levels } from './ui/Levels.tsx';
import { Food } from './ui/Food.tsx';
import { Shopping } from './ui/Shopping.tsx';
import { Progress } from './ui/Progress.tsx';
import { Rules } from './ui/Rules.tsx';
import { Data } from './ui/Data.tsx';

const TABS = [
  ['today', 'Today'], ['week', 'Week'], ['levels', 'Levels'],
  ['food', 'Food'], ['shopping', 'Shop'], ['progress', 'Progress'],
  ['rules', 'Rules'], ['data', 'Data'],
] as const;
type Tab = (typeof TABS)[number][0];

export function App() {
  const api = useStore();
  const [tab, setTab] = useState<Tab>('today');

  if (!api.ready) {
    return <p className="sub" style={{ padding: 20 }} role="status">Opening the database…</p>;
  }

  return (
    <>
      {/* Announced, not merely displayed: a write that silently failed is the exact
          failure this app exists to prevent. */}
      <div role="status" aria-live="assertive" className="sr-only">
        {api.lastFailure ?? ''}
      </div>
      {!api.durable && (
        <div role="alert" className="banner bad">
          <strong>Storage is not working. Nothing is being saved.</strong>
          <div style={{ marginTop: 5 }}>
            {api.openError ?? api.capabilities?.reason ?? 'The database did not open.'}
          </div>
        </div>
      )}
      <main key={tab}>
        {tab === 'today' && <Today api={api} />}
        {tab === 'week' && <Week api={api} />}
        {tab === 'levels' && <Levels api={api} />}
        {tab === 'food' && <Food api={api} />}
        {tab === 'shopping' && <Shopping api={api} />}
        {tab === 'progress' && <Progress api={api} />}
        {tab === 'rules' && <Rules api={api} />}
        {tab === 'data' && <Data api={api} />}
      </main>
      <nav className="tabbar" aria-label="Sections">
        {TABS.map(([id, label]) => (
          <button key={id} aria-current={tab === id ? 'page' : undefined}
                  onClick={() => { setTab(id); window.scrollTo(0, 0); }}>{label}</button>
        ))}
      </nav>
    </>
  );
}
